import commonRUTranslations from '../../../_Locale/json/ru/ru.common.json5';
import authenticationMeetingsRUTranslations from '../../../_Locale/json/ru/ru.meetings_auth.json5';
import { TCommonLocaleDictionary } from '../../../Common/services/locale/locale.translations.token';

export const AuthenticationMeetingsLocaleTranslations: TCommonLocaleDictionary = {
	ru: {
		...commonRUTranslations,
		...authenticationMeetingsRUTranslations,
	}
};
